export function getGeneralStatistics() {
    return { type: "GET_GENERAL_STATISTICS" };
}

export function getUsers() {
    return { type: "GET_USERS" };
}


export function getUser(id) {
    return { type: "GET_USER", id:id };
}

export function updateUser( values ) {
    return { type: "UPDATE_USER", values };
}

export function giveUserPromotion(id, amount) {
    return { type: "GIVE_USER_PROMOTION", id:id, amount:amount };
}

export function filterUsers(filter) {
    return { type: "FILTER_USERS", filter:filter };
}

export function createCashDiscountCode(amount, description) {
    return { type: "CREATE_CASH_DISCOUNT_CODE", amount: amount, description: description };
}

export function getDiscountCodes() {
    return { type: "GET_DISCOUNT_CODES" };
}

export function updateDiscountCode(id, status, amount, description) {
    return { type: "UPDATE_DISCOUNT_CODE", id, status, amount, description };
}

export function deleteDiscountCode(id) {
    return { type: "DELETE_DISCOUNT_CODE", id };
}

export function getRunningChallenges() {
    return { type: "GET_RUNNING_CHALLENGES" };
}

export function getFinishedChallenges() {
    return { type: "GET_FINISHED_CHALLENGES" };
}

export function getAvailableChallenges() {
    return { type: "GET_AVAILABLE_CHALLENGES" };
}

export function getChallenge(id) {
    return { type: "GET_CHALLENGE", id:id };
}

export function updateChallenge(id, fee, maxParticipans,disabled) {
    return { type: "UPDATE_CHALLENGE", id: id, fee: fee, maxParticipans: maxParticipans, disabled: disabled };
}

export function updateParticipantScore(id, participantId, score) {
    return { type: "UPDATE_PARTICIPANT_SCORE", id: id, participantId: participantId, score: score };
}

export function getLogs() {
    return { type: "GET_LOGS" };
}

export function getPayments() {
    return { type: "GET_PAYMENTS" };
}

export function getWithdrawals() {
    return { type: "GET_WITHDRAWALS" };
}

export function updateWithdrawal(id,status,reason) {
    return { type: "UPDATE_WITHDRAWAL", id, status, reason };
}

export function getServiceStatus() {
    return { type: "GET_SERVICE_STATUS" };
}

export function setServiceText(text) {
    console.log("sef");
    return { type: "SET_SERVICE_TEXT", text:text };
}

export function setServiceStatus(allowJoinChallenge, allowChallengeToStart, botsEnabled, disturbanceMessage) {
    return { type: "SET_SERVICE_STATUS", allowJoinChallenge: allowJoinChallenge, allowChallengeToStart: allowChallengeToStart, botsEnabled: botsEnabled, disturbanceMessage: disturbanceMessage };
}

export function cancelChallengeJob(id) {
    return { type: "CANCEL_CHALLENGE_JOB", id: id };
}

export function bulkEnrollChallenge(id) {
    return { type: "BULK_ENROLL_CHALLENGE", id: id };
}

export function testEnrollChallenge(id, email) {
    return { type: "TEST_ENROLL_CHALLENGE", id: id, email: email };
}